
import { StyleSheet } from 'react-native';
import * as config from './config';

export const styles = StyleSheet.create({


  /* COMMONS: LINECHART, BARCHART AND HORIZONTAL-STACKED-BAR STARTS HERE */
  viewport: {
    width: config.width,
    alignSelf: 'center',
    overflow: 'hidden',

    // backgroundColor: 'yellow',
  },
  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: 16,
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: '700',
    color: '#202124',
  },

  labelTouchable: {
    position: 'absolute',
    width: 42,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',

    borderWidth: 1,

    borderColor: "#000",
    backgroundColor: "#FFF",
  },
  touchableLabelSelected: {
    borderColor: "#FFF",
    backgroundColor: "#000"
  },
  labelText: {
    fontSize: 11,
    color: '#9ca3af',
    fontWeight: '600',
  },

  // periodSelector: {
  //   flexDirection: 'row',
  //   alignItems: 'center',
  // },
  // periodText: {
  //   display: "flex",
  //   fontSize: 14,
  //   lineHeight: 30,
  //   fontWeight: '500',
  //   color: '#FFF',
  //   backgroundColor: '#000',

  //   // minWidth: 100,

  //   // paddingLeft: 3,
  //   // paddingRight: 3,

  //   paddingLeft: 9,
  //   paddingRight: 9,

  //   textAlign: 'center',
  // },
  /* COMMONS: LINECHART, BARCHART AND HORIZONTAL-STACKED-BAR  STOPS HERE */


  /* COMMONS: BARCHART AND HORIZONTAL-STACKED-BAR STARTS HERE */
  listContainer: {
    borderTopWidth: 1,
    borderColor: '#F1F3F4',
    paddingTop: 12,
  },
  listRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 10,
  },
  leftColumn: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  bullet: {
    width: 12,
    height: 12,
    borderRadius: 4,
    marginRight: 12,
  },
  categoryName: {
    fontSize: 15,
    color: '#3C4043',
    fontWeight: '500',
  },
  rightColumn: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  categoryPercentage: {
    fontSize: 13,
    color: '#80868B',
    marginRight: 16,
    // width: 50,
    textAlign: 'right',
  },
  categoryValue: {
    fontSize: 15,
    color: '#202124',
    fontWeight: '600',
    width: 95,
    textAlign: 'right',
  },
  /* COMMONS: LINECHART, BARCHART AND HORIZONTAL-STACKED-BAR  STOPS HERE */


  /* LINECHART STARTS HERE */
  xAxis: {
    height: 30,
    position: 'absolute',
  },

  /* LINECHART STOPS HERE */

  /* BARCHART STARTS HERE */
  chartContainer: {
    justifyContent: 'flex-end',
  },
  barsContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    height: '100%',
  },
  columnGroup: {
    alignItems: 'center',
    height: '100%',
    justifyContent: 'flex-end',
  },
  barsWrapper: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'center',
    flex: 1,
    // Ensures the bars sit right on top of the grid bounds
    paddingBottom: 35,
  },
  bar: {
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    minHeight: 1,
  },
  /* BARCHART STOPS HERE */


  /* HORIZONTAL-STACKED-BAR STARTS HERE */
  controlsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
    // marginBottom: 16,
  },

  tabContainer: {
    flexDirection: 'row',
    backgroundColor: '#F1F3F4',
    borderRadius: 20,
    padding: 4,
  },
  tab: {
    paddingVertical: 6,
    paddingHorizontal: 16,
    borderRadius: 16,
  },
  activeTab: {
    backgroundColor: '#FFFFFF',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 1,
  },
  tabText: {
    fontSize: 13,
    fontWeight: '600',
    color: '#5F6368',
  },
  activeTabText: {
    color: '#005CEE',
  },

  // periodSelector: {
  //   flexDirection: 'row',
  //   alignItems: 'center',
  // },
  // periodText: {
  //   display: "flex",
  //   fontSize: 14,
  //   lineHeight: 30,
  //   fontWeight: '500',
  //   color: '#FFF',
  //   backgroundColor: '#000',

  //   // minWidth: 100,

  //   // paddingLeft: 3,
  //   // paddingRight: 3,

  //   paddingLeft: 9,
  //   paddingRight: 9,

  //   textAlign: 'center',
  // },

  barWrapper: {
    // marginBottom: 24,
  },
  barContainer: {
    flexDirection: 'row',
    width: '100%',
    height: 14,
    borderRadius: 7,
    overflow: 'hidden',
  },
  barSegment: {
    height: '100%',
  },
  /* HORIZONTAL-STACKED-BAR STOPS HERE */

});

export default styles;